const STORAGE_KEY = 'sgc_prestador_processo_sync';

const inferirFlagsPrestador = (etapaNome, statusProcesso) => {
  const nome = (etapaNome || '').toLowerCase();
  return {
    editalPublicado: nome.includes('edital') || nome.includes('chamamento'),
    recebendoPropostas: nome.includes('proposta') || nome.includes('recebimento'),
    emAnaliseComparativa:
      nome.includes('análise') || nome.includes('analise') || nome.includes('empresas') || nome.includes('comparativ'),
    processoConcluido: (statusProcesso || '').toUpperCase() === 'CONCLUIDO'
  };
};

/**
 * Publica snapshot de status do processo para consumo futuro pelo Painel do Prestador.
 * Persiste em localStorage e emite contratos:prestador-sync (sem alterar endpoints).
 */
export function publicarStatusProcessoPrestador({ processo, etapaAtual, acao, origem }) {
  if (!processo?.id) return null;

  const etapaNome = etapaAtual?.nome || processo.etapaAtual?.nome || processo.etapa_nome || null;
  const status = processo.status || processo.status_processo || null;

  const payload = {
    processoId: processo.id,
    processoCodigo: processo.codigo || processo.codigo_processo || null,
    titulo: processo.titulo || null,
    status,
    etapaId: etapaAtual?.id || processo.etapaAtual?.id || processo.etapa_atual_id || null,
    etapaNome,
    unidade: processo.unidade || null,
    acao: acao || null,
    origem: origem || 'processos',
    ...inferirFlagsPrestador(etapaNome, status),
    atualizadoEm: new Date().toISOString()
  };

  try {
    const prev = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const next = [payload, ...prev.filter((p) => p.processoId !== payload.processoId)].slice(0, 100);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore storage errors */
  }

  window.dispatchEvent(new CustomEvent('contratos:prestador-sync', { detail: payload }));
  return payload;
}
